import React, {useCallback, useState} from 'react'
import {ChakraProvider, Flex, Text, Input, Button, InputGroup, InputRightElement, Box} from '@chakra-ui/react'
import '../Views/LoginForm.css'

const LoginForm = (props) => {

    //Dati per username
    const [usernameValue, setUsernameValue] = useState('');
    const handleUsername = (event) => setUsernameValue(event.target.value);

    //Dati per password
    const [passwordValue, setPasswordValue] = useState('');
    const handlePassword = (event) => setPasswordValue(event.target.value);

    const login = useCallback(()=>{
        if(props?.onLogin) props.onLogin({
            nickname: usernameValue,
            password: passwordValue
        });
    },[props?.onLogin, passwordValue, usernameValue]);

    const [show, setShow] = React.useState(false)
    const handleClick = () => setShow(!show)

    return (
        <ChakraProvider resetCSS>
                <Flex justifyContent="center" flexDirection="column" gap=" 10px">
                    <Text>Username</Text>
                    <Input
                        className="input_field"
                        value={usernameValue}
                        onChange={handleUsername}
                        placeholder='Username'
                        size='lg'
                    />
                    <Text>Password</Text>
                    <InputGroup size='md'>
                        <Input
                            className="input_field"
                            value={passwordValue}
                            onChange={handlePassword}
                            pr='4.5rem'
                            type={show ? 'text' : 'password'}
                            placeholder='Password'
                            size='lg'
                        />
                        <InputRightElement width='4.5rem'>
                            <Button h='90%' size='sm' onClick={handleClick}>
                                {show ? 'Hide' : 'Show'}
                            </Button>
                        </InputRightElement>
                    </InputGroup>
                    <Box styles={{height:30}}/>
                    <Button
                        className="login_btn"
                        variant="solid"
                        size="md"
                        onClick={login}
                    >
                        Effettua l'accesso
                    </Button>
                </Flex>
        </ChakraProvider>
    );
}

export default LoginForm
